




























































































import {Component, Vue} from "vue-property-decorator";
import {Project, ProjectDto, ProjectService} from "@/services/project.service";
import ProgrammingLanguages from "@/components/ui/programmingLanguages.vue";
import ImageUploader from "@/components/ui/ImageUploader.vue";
import {UserFile} from "@/services/userFile.service";
import {HashMap} from "@/services/base.service";

enum ProjectMode {
    New,
    Edit,
    View,
}

@Component({components: {ImageUploader, ProgrammingLanguages}})
export default class Projects extends Vue {
    private initialized = false;
    private project!: Project | ProjectDto;
    private projectService!: ProjectService;
    private mode!: ProjectMode;

    private success: string | null = null;
    private errors: HashMap<string> = {};
    private error = false;

    private newLanguage: string = "";

    private thumbnail!: UserFile;

    private async mounted() {
        this.projectService = new ProjectService();

        switch(this.$route.query.mode) {
            case 'new':
                this.mode = ProjectMode.New;
                break;
            case 'edit':
                this.mode = ProjectMode.Edit;
                break;
            default:
                this.mode = ProjectMode.View;
        }

        if (this.mode !== ProjectMode.New) {
            const res = await this.projectService.getOne(this.$route.query.pid as string);
            if (res.success) {
                this.project = res.result;
                const thumbnail = (this.project as Project).thumbnail;
                if (thumbnail ) {
                    this.thumbnail = thumbnail;
                }
            }
            else {
                alert("Project does not exist");
                this.$router.back();
            }
        } else {
            this.project = {
                title: "",
                shortDescription: "",
                longDescription: "",
                url: "",
                sourceControlUrl: "",
                videoUrl: "",
                status: "",
                languages: [],
                thumbnailId: "",
            }
        }
        this.initialized = true;
    }

    private badgeColor(language: string): string {
        switch (language) {
            case 'Typescript': return 'badge-primary';
            case 'C++': return 'badge-success';
            case 'HTML': return 'badge-'
            default: return 'badge-dark';
        }
    }

    private get viewing(): boolean {
        return this.mode === ProjectMode.View;
    }

    private removeLanguage(lang: string) {
        this.project.languages.splice(this.project.languages.indexOf(lang), 1);
        this.$forceUpdate();
    }

    private async submit() {

        const project = this.project as ProjectDto;

        if (this.thumbnail) project.thumbnailId = this.thumbnail.id;
        this.error = false;
        this.errors = {};

        if (this.mode === ProjectMode.Edit) {
            const res = await this.projectService.put(this.$route.query.pid as string, project);
            if (res.success) {
                this.success = "Project Updated Successfully";
                this.project = res.result;
                setTimeout(() => {
                    this.success = null;
                }, 2000);
            } else {
                this.errors = res.error;
                this.error = true;
            }
        } else if (this.mode === ProjectMode.New) {
            const res = await this.projectService.post(project);
            if (res.success) {
                this.success = "Project Created Successfully";
            }
        }
    }
}
